<template>
  <div class="z-card border-0">
    <div v-if="settings_data.status === 'connected' && settings_data.trunks_ready == false">
      <div class="amo-card">
        <p>{{ $t('integrations.settings.request_info1') }}</p>
        <p>{{ $t('integrations.settings.request_info2') }}</p>
      </div>
    </div>
    <div v-else-if="settings_data.status === 'connected'">
      <z-form ref="form" v-slot="{ failed }" @submit.native.prevent="handler_submit">
        <div class="dashboard-card">
          <h2 class="mb-3">
            {{ $t('integrations.settings.integration_scenarios.incoming.title') }}
          </h2>
          <div class="widget-tab__row">
            <div
              v-for="setting in incomming_settings"
              :key="setting.title"
              class="widget-tab__block"
            >
              <h3 class="mb-3">{{ $t(setting.title) }}</h3>
              <div v-for="option in setting.options" :key="option.key" class="mx-3">
                <div class="row center">
                  <div class="static-field">
                    {{ $t(option.label) }}
                    <div v-if="option.component === 'timepicker'">
                      <time-picker
                        type="time"
                        :placeholder="$t('integrations.timepicker')"
                        format="HH:mm"
                        class="timepicker"
                        :clearable="false"
                        :value="current_value"
                        :disabled="get_disabled(option)"
                        @input="time_picker($event, option.key)"
                      />
                    </div>

                    <z-switch
                      v-else
                      :value="settings_data.widget_config[option.key]"
                      class="mx-2"
                      :disabled="get_disabled(option)"
                      @input="toggle_switch($event, option)"
                    />
                  </div>
                  <tooltip
                    class="ml-2"
                    placement="right"
                    min-width="200"
                    max-width="200"
                    theme="light"
                    :content="$t(option.tooltip)"
                  >
                    <icon size="18" type="ios-help-circle-outline" />
                  </tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dashboard-card">
          <h2 class="mb-3">
            {{ $t('integrations.settings.integration_scenarios.outgoing.title') }}
          </h2>
          <div class="widget-tab__row">
            <div
              v-for="setting in outgoing_settings"
              :key="setting.title"
              class="widget-tab__block"
            >
              <h3 class="mb-3">{{ $t(setting.title) }}</h3>
              <div v-for="option in setting.options" :key="option.key" class="mx-3">
                <div class="row center">
                  <div class="static-field">
                    {{ $t(option.label) }}
                    <z-switch
                      :value="settings_data.widget_config[option.key]"
                      class="mx-2"
                      :disabled="get_disabled(option)"
                      @input="toggle_switch($event, option)"
                    />
                  </div>
                  <tooltip
                    class="ml-2"
                    placement="right"
                    min-width="200"
                    max-width="200"
                    theme="light"
                    :content="$t(option.tooltip)"
                  >
                    <icon size="18" type="ios-help-circle-outline" />
                  </tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <i-button
            html-type="submit"
            size="large"
            type="primary"
            class="mt-4"
            style="width: 200px"
            :disabled="failed"
          >
            {{ $t('shared.component.button.save') }}
          </i-button>
        </div>
        <template v-if="failed">
          <div class="mt-4 mailing-description__error">
            {{ $t('validator.std_form_error') }}
          </div>
        </template>
      </z-form>
    </div>

    <div v-else-if="settings_data.status === 'disconnected'">
      <div class="amo-card">{{ $t('integrations.page.button.not_connected') }}</div>
    </div>
    <div v-else>
      <div class="amo-card">{{ $t('integrations.page.button.loading') }}</div>
    </div>
  </div>
</template>

<script>
  import { AmoService } from '@amo-widget/services/AmoService';

  import { get_seconds_to_time, get_time_to_seconds } from '@shared/helpers/time';

  export default {
    data: () => ({
      is_disabled: false,
      edited_field: '',
      settings_data: {
        widget_config: {}
      },
      edited_form: {},
      initial_form: {},
      incomming_settings: [
        {
          title: 'integrations.settings.integration_scenarios.incoming.known',
          options: [
            {
              label: 'integrations.settings.integration_scenarios.create_deal',
              key: 'incoming_known_contact_create_deal_if_not_exists',
              tooltip: 'integrations.settings.integration_scenarios.tooltip_deal'
            }
          ]
        },
        {
          title: 'integrations.settings.integration_scenarios.incoming.unknown',
          options: [
            {
              label: 'integrations.settings.integration_scenarios.create_contact',
              key: 'incoming_unknown_contact_create_contact',
              tooltip: 'integrations.settings.integration_scenarios.tooltip_contact',
              depend_child_keys: [
                'incoming_unknown_contact_create_deal',
                'incoming_unknown_contact_creating_type',
                'incoming_open_client_item'
              ]
            },
            {
              label: 'integrations.settings.integration_scenarios.create_deal',
              key: 'incoming_unknown_contact_create_deal',
              tooltip: 'integrations.settings.integration_scenarios.tooltip_deal2',
              disabled_keys: ['incoming_unknown_contact_create_contact'],
              depend_child_keys: ['incoming_unknown_contact_creating_type']
            },
            {
              label: 'integrations.settings.integration_scenarios.create_deal_unsorted',
              key: 'incoming_unknown_contact_creating_type',
              tooltip: 'integrations.settings.integration_scenarios.tooltip_deal_unsorted',
              disabled_keys: [
                'incoming_unknown_contact_create_contact',
                'incoming_unknown_contact_create_deal'
              ]
            }
          ]
        },
        {
          title: 'integrations.settings.integration_scenarios.incoming.missed',
          options: [
            {
              label: 'integrations.settings.integration_scenarios.create_task',
              key: 'incoming_missing_call_create_task',
              tooltip: 'integrations.settings.integration_scenarios.tooltip_task'
            },
            {
              label: 'integrations.settings.integration_scenarios.incoming.deadline_task',
              key: 'incoming_not_answered_task_complete_till_seconds',
              component: 'timepicker',
              tooltip: 'integrations.settings.integration_scenarios.tooltip_time',
              disabled_keys: ['incoming_missing_call_create_task']
            }
          ]
        },
        {
          title: 'integrations.settings.integration_scenarios.incoming.any_call',
          options: [
            {
              label: 'integrations.settings.integration_scenarios.open_contact',
              key: 'incoming_open_client_item',
              tooltip: 'integrations.settings.integration_scenarios.tooltip_open_contact',
              disabled_keys: ['incoming_unknown_contact_create_contact']
            }
          ]
        }
      ],
      outgoing_settings: [
        {
          title: 'integrations.settings.integration_scenarios.outgoing.known',
          options: [
            {
              label: 'integrations.settings.integration_scenarios.create_deal',
              key: 'outgoing_known_contact_create_deal_if_not_exists',
              tooltip: 'integrations.settings.integration_scenarios.tooltip_deal'
            }
          ]
        },
        {
          title: 'integrations.settings.integration_scenarios.outgoing.unknown',
          options: [
            {
              label: 'integrations.settings.integration_scenarios.create_contact',
              key: 'outgoing_unknown_contact_create_contact',
              tooltip: 'integrations.settings.integration_scenarios.tooltip_outgoing_contact',
              depend_child_keys: ['outgoing_unknown_contact_create_deal']
            },
            {
              label: 'integrations.settings.integration_scenarios.create_deal',
              key: 'outgoing_unknown_contact_create_deal',
              tooltip: 'integrations.settings.integration_scenarios.tooltip_deal3',
              disabled_keys: ['outgoing_unknown_contact_create_contact']
            }
          ]
        },
        {
          title: 'integrations.settings.integration_scenarios.outgoing.not_answered',
          options: [
            {
              label: 'integrations.settings.integration_scenarios.create_note',
              key: 'outgoing_no_response',
              tooltip: 'integrations.settings.integration_scenarios.tooltip_note'
            }
          ]
        }
      ]
    }),
    computed: {
      current_value() {
        const {
          incoming_not_answered_task_complete_till_seconds: seconds
        } = this.settings_data.widget_config;
        const format_value = get_seconds_to_time(seconds);
        return format_value;
      }
    },
    mounted() {
      AmoService.getSettingsData().then((response) => {
        this.settings_data = response;
        this.initial_form = { ...response.widget_config };
      });
    },
    methods: {
      get_disabled(option) {
        let is_loading = this.is_disabled && this.edited_field === option.key;
        let is_setting_off = false;
        if (option.disabled_keys) {
          is_setting_off = !!option.disabled_keys.find(
            (i) => this.settings_data.widget_config[i] === false
          );
        }

        return is_loading || is_setting_off;
      },
      set_form(key, value) {
        this.edited_form = { ...this.edited_form, [key]: value };
      },
      toggle_switch(value, option) {
        this.set_form(option.key, value);
        this.settings_data.widget_config[option.key] = value;

        if (value === false && option.depend_child_keys) {
          option.depend_child_keys.map((i) => {
            this.settings_data.widget_config[i] = false;
            this.set_form(i, false);
          });
        }
      },
      time_picker(value, key) {
        const formatted_time = get_time_to_seconds(value);
        this.$emit('input', formatted_time);
        this.set_form(key, formatted_time);
      },
      handler_submit() {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_disabled = true;
            AmoService.updateSettingsData(this.edited_form)
              .then((response) => {
                this.settings_data.widget_config = response;
              })
              .catch((error) => {
                this.settings_data.widget_config = this.initial_form;
                this.$noty.server_error(error);
              })
              .finally(() => {
                this.is_disabled = false;
              });
          }
        });
      }
    }
  };
</script>
